export enum RoutePaths {
  SIGN_IN = "/sign-in",
  TENANT_SIGN_IN = "/:tenantName/sign-in",

  DASHBOARD = "/",

  USERS = "/users",
  USER_NEW = "/user/new",
  USER = "/users/:userId",
  USER_EDIT = "/users/:userId/edit",

  TENANTS = "/tenants",
  TENANT = "/tenant/:tenantId",
  TENANT_NEW = "/tenant/new",
  TENANT_EDIT = "/tenant/:tenantId/edit",
  TENANT_IMAGE = "/tenant-image",

  ORGANIZATIONS = "/clubs",
  ORGANIZATION = "/club/:organizationId",
  ORGANIZATION_NEW = "/club/new",
  ORGANIZATION_EDIT = "/club/:organizationId/edit",

  CLAIMS = "/claims",
  CLAIM = "/claim/:internalClaimId",
  CLAIM_NEW = "/claims/:userId/new",
  CLAIM_INJURY = "/RTP-claim/:internalClaimId",
  CLAIM_INJURY_EDIT = "/RTP-claim/:internalClaimId/edit",
  CLAIM_INJURY_NOTES = "/RTP-claim/:internalClaimId/notes",

  CLAIM_CLINICAL = "/clinical-claim/:internalClaimId",
  CLAIM_CLINICAL_EDIT = "/clinical-claim/:internalClaimId/edit",

  USE_CASE = "/use-case",
  USE_CASE_CLAIMS = "/use-case-claims",
  USE_CASE_CASES = "/use-case-cases",
  USE_CASE_CREATE = "/use-case/new/:userId",
  USE_CASE_DETAILS = "/use-case/:useCaseId",
  USE_CASE_EDIT = "/use-case/:useCaseId/edit",
  USE_CASE_NOTES = "/use-case/:useCaseId/notes",

  APPOINTMENTS = "/appointments",
  APPOINTMENT = "/appointment/:appointmentId",
  APPOINTMENT_NEW = "/appointments/new",
  APPOINTMENT_EDIT = "/appointment/:appointmentId/edit",

  RECOVERY_PROGRESSES = "/recoveryProgresses",
  RECOVERY_PROGRESS = "/recoveryProgress/:userId",

  CHATS = "/chats",
  GROUP_CHAT_NEW = "/chats/group/new",
  GROUP_CHAT = "/chats/group/:conversationId",

  REPORT = "/report",
  TRACKING_REPORT = "/report/tracking-report",

  SURVEY = "/survey",
  SURVEY_DASHBOARD = "/survey/dashboard",
  SURVEY_REPORT = "/survey/report",
  SURVEY_REPORT_BY_QUESTION = "/survey/report/:qid",

  SURVEY_PROCESS = "/survey-process",
  SURVEY_PROCESS_EXECUTION = "/survey-process/:executionId",
  SURVEY_PROCESS_EXECUTION_HISTORY = "/survey-process/history/:executionId",

  SURVEY_QUESTIONNAIRES = "/survey/questionnaire",
  SURVEY_QUESTIONNAIRE_NEW = "/survey/new-question",
  SURVEY_QUESTIONNAIRE = "/survey/question/:questionnaireId",
  SURVEY_QUESTIONNAIRE_EDIT = "/survey/question/:questionnaireId/edit",

  SURVEY_GROUPS = "/survey/groups",
  SURVEY_GROUP = "/survey/group/:surveyGroupId",
  SURVEY_GROUP_NEW = "/survey/group/new",
  SURVEY_GROUP_EDIT = "/survey/group/:surveyGroupId/edit",
  SURVEY_GROUP_EDIT_QUESTIONNAIRE = "/survey/group/:surveyGroupId/update-questionnaire",

  SURVEY_EVENTS = "/survey/events",
  SURVEY_EVENT_NEW = "/survey/event/new",
  SURVEY_EVENT = "/survey/event/:eventId",
  SURVEY_EVENT_EDIT = "/survey/event/:eventId/edit",

  ACTIVE_SURVEY_EDIT = "/survey/active/edit/:internalClaimId",
  SURVEY_HISTORY_EDIT = "/survey/history/edit/:internalClaimId",

  BULK_UPLOAD = "/bulk-upload/user/:tenantId",

  PAGE_NOT_FOUND = "/404"
}
